import { Routes } from '@angular/router';

import { HomeComponent } from './features/general/home/home.component'
import { NotFoundComponent } from './features/general/not-found/not-found.component';

export const routes: Routes = [
  { path: '', component: HomeComponent, },
  { path: 'erajaya', component: HomeComponent, },
  {
    path: 'erajaya/confirmation',
    loadComponent: () => import('./features/general/confirmation/confirmation.component')
      .then(mod => mod.ConfirmationComponent)
  },
  { path: '**', component: NotFoundComponent }
];